import React from "react";
import { Link } from "gatsby";
import { cn } from "@/utils";

import { link } from "./navbar.module.css";

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
}

const NavLink: React.FC<NavLinkProps> = ({ to, children }) => {
  return (
    <Link to={to} className={link}>
      {children}
    </Link>
  );
};

interface NavButtonProps {
  to: string;
  children: React.ReactNode;
}

const NavButton: React.FC<NavButtonProps> = ({ to, children }) => {
  return (
    <Link
      to={to}
      className={cn(
        "text-sm text-dark inline-block ml-6 py-[6px] px-4 border-y border-transparent bg-primary-light  hover:border-dark"
      )}
    >
      {children}
    </Link>
  );
};

export { NavLink, NavButton };
